const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuzuki(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg4259",
    viewBox: "0 0 496.00001 332.42999",
    height: 332.42999,
    width: 496,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "refine_final",
    d: "m 223.59651,49.000052 46.92657,31.517149 c 9.72343,6.530577 19.67771,12.909917 36.82991,12.909917 26.69981,0 50.48049,-19.403463 50.48049,-19.403463 L 247.61833,1.481344e-4 c 0,0 -12.02703,13.2232368656 -49.772,36.7324318656 -39.63096,24.684824 -60.41129,31.852894 -60.41129,31.852894 l 142.24783,95.614216 -9.35135,6.12524 -45.63446,-30.64917 c -9.67576,-6.49849 -19.66829,-12.90352 -36.82225,-12.90352 -26.6987,0 -50.42964,19.45573 -50.42964,19.45573 l 110.22138,74.02775 c 0,0 12.0288,-13.22381 49.77376,-36.73293 39.62984,-24.68425 60.41193,-31.85289 60.41193,-31.85289 L 214.25658,55.133192 Z",
    style: {
      fill: "#de0039",
      strokeWidth: 7.98271
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g482",
    transform: "matrix(4.5054987,0,0,4.5675933,-152.79187,228.99519)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.06364,
    y: 5.95997,
    width: 5.9363699,
    height: 16.030849,
    id: "rect6",
    style: {
      fill: "#00368f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.43102,21.99082 122.26057,16.12233 122.26057,21.99082 116.31824,21.99082 116.31824,5.95997 122.26057,5.95997 122.26057,11.65301 128.89495,5.95997 136.67496,5.95997 127.53718,13.76804 136.39792,21.99082 ",
    id: "polygon8",
    style: {
      fill: "#00368f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 105.0573,22.60581 c -8.16994,0 -9.15016,-3.41103 -9.17666,-5.97666 -0.01442,-1.42581 -0.03136,-4.05855 -0.03136,-4.8569 V 5.95661 h 5.68442 v 9.26336 c 0,2.35523 1.08684,3.40538 3.5236,3.40538 2.43723,0 3.52407,-1.05015 3.52407,-3.40538 V 5.9566 h 5.68473 v 5.81564 c 0,0.78424 -0.0171,3.41698 -0.0317,4.8569 -0.0265,2.56564 -1.00688,5.97666 -9.17713,5.97666 z",
    id: "path10",
    style: {
      fill: "#00368f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.61007,9.89199 75.52169,9.89199 75.52169,5.95997 93.86465,5.95997 93.86465,9.28084 84.33491,18.04107 93.83439,18.04107 93.83439,21.99082 75.20953,21.99082 75.20953,18.67261 ",
    id: "polygon12",
    style: {
      fill: "#00368f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 64.32688,22.60581 c -8.17103,0 -9.15079,-3.41103 -9.17697,-5.97666 -0.01442,-1.4186 -0.0312,-4.05134 -0.0312,-4.8569 V 5.95661 h 5.68426 v 9.26336 c 0,2.35523 1.08684,3.40538 3.52391,3.40538 2.43707,0 3.52391,-1.05015 3.52391,-3.40538 V 5.9566 h 5.6841 v 5.81564 c 0,0.80556 -0.01678,3.43831 -0.0312,4.8569 -0.02618,2.56564 -1.00594,5.97666 -9.17681,5.97666 z",
    id: "path14",
    style: {
      fill: "#00368f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 44.1849,22.37948 c -8.50075,0 -9.99006,-2.60452 -10.27259,-5.44641 h 7.19144 c 0.65238,1.89805 2.57316,1.89805 3.20909,1.89805 0.76919,0 2.54024,-0.13295 2.54024,-1.36654 0,-1.08025 -1.20552,-1.19659 -3.03035,-1.37219 -0.23831,-0.02289 -0.4887,-0.04704 -0.74991,-0.07463 -5.84841,-0.61334 -8.81777,-1.59231 -8.81777,-5.24197 0,-1.59012 0.87267,-5.28885 8.9559,-5.28885 l 0.07322,1.6e-4 c 6.18221,0.0174 9.75127,1.9479 9.81446,5.30123 H 46.48949 C 46.04296,9.19915 44.28038,8.95927 43.25987,8.95927 c -0.39447,0 -1.72668,0.04798 -2.30616,0.66728 -0.19927,0.21291 -0.29021,0.47161 -0.27045,0.76919 0.05346,0.87298 1.711,1.06112 3.80942,1.29944 0.43147,0.04892 0.88208,0.10003 1.3413,0.15961 5.25608,0.6723 7.8109,2.3891 7.8109,5.24855 0,1.23139 -0.67308,5.25137 -9.33517,5.27615 h -0.1248 z",
    id: "path16",
    style: {
      fill: "#00368f"
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuzuki);
export default __webpack_public_path__ + "static/media/Suzuki.8549b611c28471976c701712cd412f67.svg";
export { ForwardRef as ReactComponent };